import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData } from '../../services/Api';

const StoreStatusContext = createContext();

export const useStoreStatus = () => useContext(StoreStatusContext);

export const StoreStatusProvider = ({ children }) => {

    const [storeStatus, setStoreStatus] = useState(null);

    // ✅ FUNÇÃO FORA DO useEffect
    const fetchStatus = useCallback(async () => {
        try {
            const result = await fetchData('/HorarioFuncionamento/status');
            setStoreStatus(result);
        } catch (error) {
            console.error("Erro ao buscar status da loja:", error);
        }
    }, []);

    // Continua carregando ao iniciar app
    useEffect(() => {
        fetchStatus();
    }, []);

    return (
        <StoreStatusContext.Provider value={{ 
            storeStatus, 
            setStoreStatus,
            fetchStatus // 🔥 agora exposta
        }}>
            {children}
        </StoreStatusContext.Provider>
    );
};
